package gr.tech.site.util

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement

object porridgeTimer {
    var porridgeCounter = 0

    fun startTimer() {
        window.setInterval(
            handler = {
                porridgeCounter++
            },
            timeout = 1000
        )
    }
}

fun isABear(): Boolean {
    val name = (document.getElementById("name") as? HTMLInputElement)?.value?.trim() ?: ""
    val address = (document.getElementById("address") as? HTMLInputElement)?.value?.trim() ?: ""
    val phoneNumber = (document.getElementById("phone_number") as? HTMLInputElement)?.value?.trim() ?: ""
    val petCheck = (document.getElementById("pet") as? HTMLInputElement)?.value?.trim() ?: ""

    val userAgent = window.navigator.userAgent

    if (
        name.isNotBlank() ||
        address.isNotBlank() ||
        phoneNumber.isNotBlank() ||
        porridgeTimer.porridgeCounter < 5 ||
        petCheck != "waffles" ||
        userAgent.contains("curl")
    ) {
        // Bear spotted
        return true
    } else {
        // No Bear
        return false
    }
}

/*
    Composable form that is a honeypot for bots to fill in if they visit the form.
    Is used inside the contactForm() composable, automatically called and handled in the form.
    If information is entered, the callback is triggered and can do whatever necessary with it.

    Parameters: onSpot callback -> returns a boolean that shows this honeypot was filled in.
*/
@Composable
fun bearHuntingForm(onSpot: (Boolean) -> Unit = { _: Boolean -> }) {

    // Wrapper clips the entire form off-screen. Does NOT use display:none or visibility:hidden
    // so bots that parse HTML still see and fill the fields.
    Div(attrs = HoneypotWrapperStyle.toAttrs()) {
        Form(
            action = "https://websubmitfrontend.com/api/submit-lead.php",
            attrs = Modifier.toAttrs {
                attr("method", "POST")
                id("inputForm")
                    .onSubmit {
                        it.preventDefault()
                    }
            }
        ) {
            Label(forId = "name") { Text("Your Name") }
            Input(InputType.Text, attrs = Modifier.toAttrs {
                autoComplete(AutoComplete.off)
                id("name")
                name("name")
                placeholder("Your name")
                maxLength(100)
                tabIndex(-1)
                onChange { onSpot(true) }
                onInput { onSpot(true) }
            })
            Label(forId = "address") { Text("Your email") }
            Input(InputType.Text, attrs = Modifier.toAttrs {
                autoComplete(AutoComplete.off)
                id("address")
                name("address")
                placeholder("Your address")
                tabIndex(-1)
                onChange { onSpot(true) }
                onInput { onSpot(true) }
            })
            Label(forId = "pet") { Text("Your pet") }
            Input(InputType.Text, attrs = Modifier.toAttrs {
                autoComplete(AutoComplete.off)
                id("pet")
                name("pet")
                placeholder("pet")
                value("waffles")
                tabIndex(-1)
                onChange { onSpot(true) }
                onInput { onSpot(true) }
            })
            Label(forId = "phone_number") { Text("Phone Number") }
            Input(InputType.Text, attrs = Modifier.toAttrs {
                autoComplete(AutoComplete.off)
                id("phone_number")
                name("phone_number")
                placeholder("phone number")
                tabIndex(-1)
                onChange { onSpot(true) }
                onInput { onSpot(true) }
            })
        }
    }
}

/*
    HONEY POT STYLES
*/

// Clips the entire honeypot form off-screen without display:none/visibility:hidden,
// so HTML-parsing bots still see the fields while no browser can render them.
val HoneypotWrapperStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .left((-9999).px)
            .top(0.px)
            .width(0.px)
            .height(0.px)
            .overflow(Overflow.Hidden)
    }
}
